import React from "react";
import SharedNewPasswordSetContent from "../components/new_password_set_content";

export default function NewPasswordSetContent({ baseUrl }: { baseUrl: string }) {
  return (
    <SharedNewPasswordSetContent
      baseUrl={baseUrl}
      title="Password Reset Successful"
      description="  You can now use your new password to sign into your account."
    />
  );
}
